/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 10:40:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

import { IDeviceSwitchData } from '@root/types/device';
import { http } from '@shared';

// 已订阅的列表
const getSubscriptionList = ({ homeId }: { homeId: string }) => {
  return http.request({
    url: '/api/ipc/recordPlanController/getPackageBindDevList',
    method: 'POST',
    data: {
      homeId,
      pageNum: 1,
      pageSize: 100,
    },
  });
};

// 订阅详情
const getSubscriptionDetail = (packageId: string) => {
  return http.request({
    url: '/api/ipc/recordPlanController/getPackageSubscribeInfo',
    params: {
      packageId,
    },
  });
};

//  设备切换套餐
const deviceSwitchPackage = (data: IDeviceSwitchData) => {
  return http.request({
    url: '/api/ipc/recordPlanController/deviceSwitchPackage',
    method: 'POST',
    data,
  });
};

//  取消套餐订阅
const updateSubscribeStatus = ({
  packageId,
  subscribeStatus,
}: {
  packageId: string;
  subscribeStatus: number;
}) => {
  return http.request({
    url: '/api/ipc/recordPlanController/updateSubscribeStatus',
    params: {
      packageId,
      subscribeStatus,
    },
  });
};

// 修改设备锁定状态
const updateDeviceLockStatus = ({
  deviceId,
  lockStatus,
}: {
  deviceId: string;
  lockStatus: number;
}) => {
  return http.request({
    url: '/api/ipc/recordPlanController/updateDeviceLockStatus',
    params: {
      deviceId,
      lockStatus,
    },
  });
};

// 苹果降级保留的设备选择页面
const getDowngradeDevList = (packageId: string) => {
  return http.request({
    url: '/api/ipc/ApplePay/downgradeDevList',
    params: {
      packageId,
    },
  });
};

export {
  getSubscriptionList,
  getSubscriptionDetail,
  deviceSwitchPackage,
  updateSubscribeStatus,
  updateDeviceLockStatus,
  getDowngradeDevList,
};
